import React from 'react'
import { Box, Text, VStack, SimpleGrid } from '@chakra-ui/react'
import TextContentAbout from '../components/TextContentAbout'
import Carousel from '../components/Carousel'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next'


const data = [
  {
    type: 'subTitle',
    content: 'teachers.iva',
  },
  {
    type: 'content',
    content: 'teachers.bio1',
  },
  {
    type: 'content',
    content: 'teachers.bio2',
  },
  {
    type: 'content',
    content: 'teachers.bio3',
  },
  {
    type: 'list',
    content: '',
    listElements: [
      'teachers.list1',
      'teachers.list2',
      'teachers.list3',
      'teachers.list4',
      'teachers.list5'
    ]
  },
  {
    type: 'content',
    content: 'teachers.bio4'
  }
]

const carouselPics = [
  'https://res.cloudinary.com/daduurukb/image/upload/v1693500477/inchilza/deleva.jpg',
]


const TeachersPage = () => {
    const { t } = useTranslation()
    const translatedData = data.map((item) => ({
      ...item,
      content: item.content ? t(item.content) : item.content,
      listElements: item.listElements?.map((listItem) => t(listItem)),
    }))

    return (
        <>
            <Box
                bgGradient={'linear(to-tr, pink.100, orange.200)'}
                width={'100%'}
                position="relative"
                padding={'12vh 0vw'}
                 >
                    <VStack
                        width={{base:'90vw',md:'70vw'}}
                        margin={'auto'}
                      >
                        <Text
                            fontSize={'2xl'}
                            fontFamily={'heading'}
                            fontWeight={'bold'}
                            padding={'2vh 0'}
                            >{t('teachers.title')}</Text>
                            <SimpleGrid
                              columns={{base:1, md:1}}
                              bg={'rgba(255,255,255,0.5)'}
                              borderRadius={'10'}
                              w={'100%'}
                              gap={'4vw'}
                              minH={{base:'20vh', md:'50vh'}}
                              padding={'6vh 3vw'}>
                                <Carousel images={carouselPics}/>
                                  <VStack
                                    alignItems={'left'}>
                                  {
                                    translatedData.map((item, index) => {
                                      return (
                                        <TextContentAbout
                                          type={item.type}
                                          content={item.content}
                                          align={'left'}
                                          key={index}
                                          listElements={item.listElements}
                                        />
                                      )
                                    })
                                  }
                                  </VStack>
                            </SimpleGrid>
    
                    </VStack>
    
            </Box>
            <Footer></Footer>
    
        </>
      )
}

export default TeachersPage
